import { Badge as BadgeMantine } from '@mantine/core';
import React from 'react';
import '../../../scss/vendors/bstyles.scss';
import { BadgeProps } from '.';

const Badge: React.FC<BadgeProps> = ({
  backgroundColor,
  children,
  color,
  className,
  leftSection,
  rightSection,
  style,
  variant = 'filled'
}) => {
  return (
    <BadgeMantine
      leftSection={leftSection}
      rightSection={rightSection}
      className={className}
      style={{ ...style, backgroundColor, textTransform: 'capitalize' }}
      color={color}
      variant={variant}
    >
      {children}
    </BadgeMantine>
  );
};

export default Badge;
